export const isMobile = window.innerWidth < 600;